import { render, staticRenderFns } from "./PaymentTermsModal.vue?vue&type=template&id=47471f00&scoped=true"
import script from "./PaymentTermsModal.vue?vue&type=script&lang=js"
export * from "./PaymentTermsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47471f00",
  null
  
)

export default component.exports